import {
  Drawer,
  Skeleton,
} from 'antd';
import ActionTimeline from 'components/ActionTimeline';
import useFetchedData from 'hooks/useFetchedData';
import React from 'react';

function TimelineDrawer({ workflowId, onclose }) {
  const { data: workflow } = useFetchedData(workflowId && `v1/organizations/{{organizationId}}/workflows/${workflowId}/`, (data) => data?.data);

  return (
    <Drawer
      title={workflow?.name}
      placement="right"
      onClose={onclose}
      open={Boolean(workflowId)}
      width={600}
    >
      {workflow ? (
        <ActionTimeline
          trigger={workflow.trigger}
          actions={workflow.actions || []}
        />
      ) : (
        <Skeleton active paragraph={{ rows: 10 }} />
      )}
    </Drawer>
  );
}

export default TimelineDrawer;
